module.exports = __webpack_public_path__ + "static/media/ic-payment.e525b1c4.svg";